function colorLookup(input){
  var color;
  input = +input;
  switch (input) {
    case 0:
        color = "#1E3250";
        break;
    case 1:
        color = "#4C6B8B";
        break;
    case 2:
        color = "#699CC6";
        break;
    case 3:
        color = "#AECFE6";
        break;
    case 4:
        color = "#6E417A";
        break;
    case 5:
        color = "#297D6D";
        break;
    case  6:
        color = "#CCB146";
        break;
    case  7:
        color = "#EC3740";
        break;
    case  8:
        color = "#889CB2";
        break;
    case 9:
        color = "#9E80A6";
        break;
    case 10:
        color = "#70A89E";
        break;
    case 11:
        color = "#DDCB84";
        break;
    case 12:
        color = "#F27A80";
        break;
    case 13:
        color = "#C3CED8";
        break;
    case 14:
        color = "#CDDEEC";
        break;
    case 15:
        color = "#E4EFF7";
        break;
    case  16:
        color = "#CFC0D3";
        break;
    case  17:
        color = "#B8D4CE";
        break;
    case  18:
        color = "#EEE5C1";
        break;
    case 19:
        color = "#F9BCBF";
        break;
    case -99:
        color = "#000000";

  }

  return color;
}

function colorLookupSDG(input){

  var color;
  input = +input;
  switch (input) {
    case 1:
        color = "#e6162d ";
        break;
    case 2:
        color = "#cfa41e ";
        break;
    case 3:
        color = "#2c9f44 ";
        break;
    case 4:
        color = "#bf1a33 ";
        break;
    case 5:
        color = "#ea3f29";
        break;
    case  6:
        color = "#31abda";
        break;
    case  7:
        color = "#f8bc00";
        break;
    case  8:
        color = "#8c1238";
        break;
    case 9:
        color = "#ee6f1f";
        break;
    case 10:
        color = "#dd0085";
        break;
    case 11:
        color = "#f4a119";
        break;
    case 12:
        color = "#cb9022";
        break;
    case 13:
        color = "#487a3c";
        break;
    case 14:
        color = "#2878bd";
        break;
    case 15:
        color = "#41b443";
        break;
    case  16:
        color = "#1c508c";
        break;
    case  17:
        color = "#203169";
        break;
    case  18:
        color = "#969696";
        break;
    case  19:
        color = "#969696";
        break;

    case -99:
        color = "#000000";
    }
  return color;
}
export {colorLookup,colorLookupSDG};



// WEBPACK FOOTER //
// ./src/App/utils/colorHash.js